export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const NO_ORGS_SELECTED_MESSAGE =
  'Please select the organizations that you want to create plans for';
